export default __webpack_public_path__ + "static/font-80ae32b0050d8cc704fa1f6e45557d7c.woff2";